import { render, staticRenderFns } from "./blogs1.vue?vue&type=template&id=838f364e&scoped=true"
import script from "./blogs1.vue?vue&type=script&lang=js"
export * from "./blogs1.vue?vue&type=script&lang=js"
import style0 from "./blogs1.vue?vue&type=style&index=0&id=838f364e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838f364e",
  null
  
)

export default component.exports